import React, { useEffect, useState } from "react";
import {
    Table,
    Pagination,
    RowsPerPageSelect,
} from "../../../components/Table";
import Modal from "../../../components/Modal/Modal";
import { FiDownload } from "react-icons/fi";
import Select from "react-select";
import Accordion from "../../../components/Accordion/Accordion";
import { DateRange } from "react-date-range-ts";
import generatingFileAnimation from "../../../assets/LottieIcons/fileGenerating.json";

import {
    endOfDay,
    endOfMonth,
    format,
    startOfDay,
    startOfMonth,
    subDays,
} from "date-fns";
import LottiePlayer from "../../../components/Lottie/LottiePlayer";
import { useMutation, useQuery } from "@apollo/client";
import {
    GENERATE_REPORT,
    GET_REPORTS,
    GET_VENDORS_FOR_REPORT
} from "../../../Qurries";
import { FaDownload } from "react-icons/fa6";
import { toast } from "react-toastify";
import { RiRefreshLine } from "react-icons/ri";

const MAX_RANGE_DAYS = 30;
const DATE_RANGE_15_DAYS = 15;
const SELECT_ALL_FIELDS_OPTION_VALUE = "__SELECT_ALL_FIELDS__";

let TRANSACTION_FIELDS = [
    "collect_id",
    "custom_order_id",
    "order_amount",
    "transaction_amount",
    "payment_method",
    "school_name",
    "school_id",
    "status",
    "student_id",
    "student_name",
    "student_email",
    "student_phone",
    "gateway",
    "capture_status",
    "createdAt",
    "transactionDate",
];

let VENDOR_TRANSACTION_FIELDS = [
    "vendor_id",
    "name",
    "collect_id",
    "custom_order_id",
    "amount",
    "transaction_amount",
    "payment_method",
    "school_name",
    "school_id",
    "status",
    "student_id",
    "student_name",
    "student_email",
    "student_phone",
    "gateway",
    "createdAt",
    "payment_time",
];

export const REFUND_REPORT_FIELDS = [
    '_id',
    'order_id',
    'school_id',
    'trustee_id',
    'status',
    'refund_amount',
    'order_amount',
    'transaction_amount',
    'reason',
    'custom_id',
    'gateway',
    'isSplitRefund',
    'split_vendor_ids',
    'split_amounts',
    'additonalInfo',
    'gatway_refund_id',
    'createdAt',
]

export const DISPUTE_REPORT_FIELDS = [
    '_id',
    'dispute_id',
    'collect_id',
    'custom_order_id',
    'dispute_amount',
    'dispute_created_date',
    'dispute_respond_by_date',
    'dispute_status',
    'dispute_type',
    'dispute_updated_date',
    'gateway',
    'order_amount',
    'payment_amount',
    'reason_description',
    'dispute_remark',
    'bank_reference',
    'settlement_id',
    'utr_number',
    'school_name',
    'student_name',
    'school_id',
    'trustee_id',
    'documents',
    'event_steps',
];


export default function Reports() {
    const [openModal, setModal] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [itemsPerRow, setItemsPerRow] = useState<{
        name: number;
    }>({
        name: 10,
    });
    const {
        data,
        loading: reportLoading,
        refetch,
    } = useQuery(GET_REPORTS, {
        variables: { page: currentPage, limit: itemsPerRow.name },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    });




    const [selectedVendorIds, setSelectedVendorIds] = useState<string[]>([]);
    const [SelectedFields, setSelectedFields] = useState<string[]>([]);
    console.log(SelectedFields, "SelectedFields");
    const [generate] = useMutation(
        GENERATE_REPORT,
        {
            refetchQueries: [
                { query: GET_REPORTS, variables: { page: 1, limit: 10 } },
            ],
            awaitRefetchQueries: true,
        }
    );
    const [selectedRange, setSelectedRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
    });

    const [reportData, setReportData] = useState({
        startDate: selectedRange.startDate,
        endDate: selectedRange.endDate,
        name: "",
        format: "",
        email: "",
        type: "",
        vendor_list: [] as string[],
        SelectedFields: [] as string[],
    });

    const { data: vendorData, loading: vendorLoading } = useQuery(GET_VENDORS_FOR_REPORT, {
        skip: !["VENDOR_TRANSACTION_REPORT", "VENDOR_SETTLEMENT_RECON", "VENDOR_N_SETTLEMENT_RECON"].includes(reportData?.type),
    });

    useEffect(() => {
        if (!openModal) {
            setSelectedVendorIds([]);
            setReportData({
                startDate: new Date(),
                endDate: new Date(),
                name: "",
                format: "",
                email: "",
                type: "",
                vendor_list: [],
                SelectedFields: [],
            });
            setSelectedRange({
                startDate: new Date(),
                endDate: new Date(),
                key: "selection",
            });
        }
    }, [openModal]);

    const handlePresetFilter = (type: any) => {
        let startDate, endDate;

        switch (type) {
            case "today":
                startDate = startOfDay(new Date());
                endDate = endOfDay(new Date());

                break;
            case "last7days":
                startDate = subDays(new Date(), 7);
                endDate = new Date();

                break;
            case "thisMonth":
                startDate = startOfMonth(new Date());
                endDate = endOfMonth(new Date());

                break;
            case "lastMonth":
                startDate = startOfMonth(subDays(new Date(), 30));
                endDate = endOfMonth(subDays(new Date(), 30));

                break;
            default:
                startDate = new Date();
                endDate = new Date();
                break;
        }

        setSelectedRange({
            startDate,
            endDate,
            key: "selection",
        });
    };

    const fields =
        reportData.type === "VENDOR_TRANSACTION_REPORT"
            ? VENDOR_TRANSACTION_FIELDS
            : reportData.type === "DISPUTE_REPORT"
                ? DISPUTE_REPORT_FIELDS
                : reportData.type === 'REFUND_REPORT'
                    ? REFUND_REPORT_FIELDS
                    : TRANSACTION_FIELDS;



    const items = [
        {
            title: "What report is this?",
            subtitle: "Report type",
            content: (
                <div className="flex flex-col gap-y-4 pb-4">
                    <div className="flex flex-col px-4 bg-gray-100">
                        <label htmlFor="report" className="my-2">
                            Select Report required *
                        </label>
                        <Select
                            closeMenuOnSelect={true}
                            onChange={(selectedOption) => {
                                setReportData((prevData) => ({
                                    ...prevData,
                                    type: selectedOption ? selectedOption.value : "",
                                    school_list: [],
                                    vendor_list: [],
                                    SelectedFields: [],
                                }));
                                setSelectedVendorIds([]);
                                setSelectedFields([]);
                            }}
                            options={[
                                {
                                    value: "SETTLEMENT_REPORT",
                                    label: "Merchant Settlement Report",
                                },
                                {
                                    value: "SETTLEMENT_VENDOR",
                                    label: "Vendor Settlement Report",
                                },
                                {
                                    value: "SETTLEMENT_RECON",
                                    label: "Settlement Reconciliation Report",
                                },
                                {
                                    value: "VENDOR_SETTLEMENT_RECON",
                                    label: "Vendor Settlement Reconciliation Report",
                                },
                                {
                                    value: "VENDOR_N_SETTLEMENT_RECON",
                                    label: "Merchant and vendor settlement reconciliation Report",
                                },
                                { value: "TRANSACTION_REPORT", label: "Transaction Report" },
                                {
                                    value: "VENDOR_TRANSACTION_REPORT",
                                    label: "Vendor Transaction Report",
                                },
                                { value: "REFUND_REPORT", label: "Refund Report" },
                                { value: "DISPUTE_REPORT", label: "Dispute Report" },
                            ]}
                            isSearchable={false}
                        />
                        <p className="text-[9px] my-2 text-gray-500">
                            Please select the report you want to download.
                        </p>
                    </div>

                    {(reportData.type === "VENDOR_TRANSACTION_REPORT" || reportData.type === "VENDOR_SETTLEMENT_RECON" || reportData.type === "VENDOR_N_SETTLEMENT_RECON") && (
                        <div className="flex flex-col px-4 bg-gray-100">
                            <label className="my-2">Select Vendors</label>

                            <Select
                                isMulti
                                isLoading={vendorLoading}
                                placeholder="Select Vendors"
                                value={selectedVendorIds.map((id) => {
                                    const vendor = vendorData?.getVendorsForMerchantReport.find((v: any) => v.vendor_id === id);
                                    return vendor ? { value: vendor.vendor_id, label: vendor.name } : null;
                                }).filter(Boolean)}
                                onChange={(options) => {
                                    const selected = options ? options.map((opt) => opt?.value) : [];
                                    setSelectedVendorIds(selected);
                                    setReportData((prev) => ({
                                        ...prev,
                                        vendor_list: selected,
                                    }));
                                }}
                                options={vendorData?.getVendorsForMerchantReport?.map((v: any) => ({
                                    value: v.vendor_id,
                                    label: v.name,
                                }))}
                            />
                        </div>
                    )}

                    {(reportData.type === "TRANSACTION_REPORT" ||
                        reportData.type === "VENDOR_TRANSACTION_REPORT" ||
                        reportData.type === "DISPUTE_REPORT"  ||
                         reportData.type === "REFUND_REPORT") && (
                            <div className="flex flex-col px-4 bg-gray-100">
                                <label className="my-2">Select Fields</label>

                                <Select
                                    placeholder="Select Fields"
                                    isMulti
                                    value={SelectedFields.map((field) => ({
                                        value: field,
                                        label: field,
                                    }))}
                                    onChange={(options) => {
                                        const selectedValues = options
                                            ? options.map((opt) => opt.value as string)
                                            : [];

                                        const shouldToggleAll =
                                            selectedValues.indexOf(SELECT_ALL_FIELDS_OPTION_VALUE) !==
                                            -1;

                                        const selected = shouldToggleAll
                                            ? SelectedFields.length === fields.length
                                                ? []
                                                : [...fields]
                                            : selectedValues;

                                        setSelectedFields(selected);
                                        setReportData((prev) => ({
                                            ...prev,
                                            SelectedFields: selected,
                                        }));
                                    }}
                                    options={[
                                        {
                                            value: SELECT_ALL_FIELDS_OPTION_VALUE,
                                            label: "Select All",
                                        },
                                        ...fields.map((field) => ({
                                            value: field,
                                            label: field,
                                        })),
                                    ]}
                                />
                            </div>
                        )}




                    <div className="flex flex-col p-4 bg-gray-100">
                        <label htmlFor="email" className="my-2">
                            Save Report As optional (optional)
                        </label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            onChange={(e) => {
                                setReportData((prevData) => ({
                                    ...prevData,
                                    name: e.target.value,
                                }));
                            }}
                            className="border border-gray-300 focus:ring-2 ring-blue-600 rounded-md px-4 py-2 focus:outline-none "
                            placeholder="Eg: Transaction Report"
                        />
                        <p className="text-[9px] my-2 text-gray-500">
                            Enter file name for your report.
                        </p>
                    </div>
                    <div className="flex flex-col px-4 bg-gray-100">
                        <label htmlFor="report" className="my-2">
                            Select Format optional (optional)
                        </label>
                        <Select
                            closeMenuOnSelect={true}
                            onChange={(selectedOption) => {
                                setReportData((prevData) => ({
                                    ...prevData,
                                    format: selectedOption ? selectedOption.value : "",
                                }));
                            }}
                            options={[
                                { value: "csv", label: "CSV" },
                                // { value: "pdf", label: "PDF" },
                                // { value: "excel", label: "Excel" },
                            ]}
                            isSearchable={false}
                        />
                        <p className="text-[9px] my-2 text-gray-500">
                            Please select the format you want to download the report in.
                        </p>
                    </div>
                </div>
            ),
        },
        {
            title: "What will you receive in this report?",
            subtitle: "Period of data, time, date etc.",
            content: (
                <div className="flex flex-col gap-y-4 pb-4">
                    <div className="flex flex-col p-4 bg-gray-100">
                        <label htmlFor="report" className="my-2">
                            Select Duration *
                        </label>

                        <div className="flex bg-white ">
                            <div className="flex flex-col w-40 p-4 gap-4 mb-2">
                                <span
                                    onClick={() => handlePresetFilter("today")}
                                    className="font-normal px-3 py-1  text-black text-xs hover:bg-gray-100 cursor-pointer"
                                >
                                    Today
                                </span>
                                <span
                                    onClick={() => handlePresetFilter("last7days")}
                                    className="font-normal px-3 py-1  text-black text-xs hover:bg-gray-100 cursor-pointer"
                                >
                                    Last 7 Days
                                </span>
                                <span
                                    onClick={() => handlePresetFilter("thisMonth")}
                                    className="font-normal px-3 py-1  text-black text-xs hover:bg-gray-100 cursor-pointer"
                                >
                                    This Month
                                </span>
                                <span
                                    onClick={() => handlePresetFilter("lastMonth")}
                                    className="font-normal px-3 py-1  text-black text-xs hover:bg-gray-100 cursor-pointer"
                                >
                                    Last Month
                                </span>
                            </div>
                            <DateRange
                                ranges={[selectedRange]}
                                rangeColors={["#1E1B59"]}
                                className="w-full"
                                onChange={(item: any) => {
                                    const { startDate, endDate } = item.selection;

                                    const diffInMs = endDate.getTime() - startDate.getTime();
                                    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

                                    if (
                                        reportData.type === "VENDOR_N_SETTLEMENT_RECON" &&
                                        diffInDays > DATE_RANGE_15_DAYS
                                    ) {
                                        const adjustedEndDate = new Date(startDate);
                                        adjustedEndDate.setDate(
                                        startDate.getDate() + DATE_RANGE_15_DAYS,
                                        );
                                        setSelectedRange({
                                        ...item.selection,
                                        endDate: adjustedEndDate,
                                        });

                                    } else if (diffInDays <= MAX_RANGE_DAYS) {
                                        setSelectedRange(item.selection);
                                    } else {
                                        const adjustedEndDate = new Date(startDate);
                                        adjustedEndDate.setDate(
                                            startDate.getDate() + MAX_RANGE_DAYS
                                        );

                                        setSelectedRange({
                                            ...item.selection,
                                            endDate: adjustedEndDate,
                                        });
                                    }
                                }}
                                maxDate={new Date()}
                                showDateDisplay={true}
                            />
                        </div>
                    </div>
                </div>
            ),
        },
    ];

    useEffect(() => {
        setReportData((prevData) => ({
            ...prevData,
            startDate: selectedRange.startDate,
            endDate: selectedRange.endDate,
        }));
    }, [selectedRange]);

    const handlePageChange = (page: any) => {
        setCurrentPage(page);
    };

    // useEffect(() => {
    //   const reports = data?.getMerchantReportsLogs?.reports || [];
    //   startPolling(3000);
    //   const allResolved =
    //     reports.length > 0 &&
    //     reports.every(
    //       (r: any) =>
    //         (r.status === "COMPLETED" && r.url?.trim() !== "") ||
    //         r.status === "FAILED" ||
    //         r.status === "DELETED" ||
    //         r.status !== "PENDING"
    //     );
    //   console.log("polling", pollingActive && allResolved);

    //   if (pollingActive && allResolved) {
    //     stopPolling();
    //     setPollingActive(false);
    //   }
    // }, [data?.getMerchantReportsLogs?.reports, pollingActive, stopPolling]);

    return (
        <div className="w-full pt-2">
            <Modal
                className=" max-w-2xl "
                open={openModal}
                setOpen={setModal}
                hasChanged={true}
            >
                <div className="p-4 ">
                    <h2 className="text-lg font-semibold mb-4">
                        Download report for your business
                    </h2>
                    <p className="text-sm text-gray-600 pb-4">
                        Here you can view the details of the selected report.
                    </p>

                    <div className="overflow-y-auto h-[550px]  ease-in-out border-t border-gray-200 pt-4 ">
                        <Accordion items={items} multiple={false} />
                        <div className="flex justify-end items-center gap-x-4 ">
                            <button
                                onClick={() => setModal(false)}
                                className="mt-4 border-2 text-black px-6 py-2 rounded-md"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={async () => {
                                    if (
                                        !reportData.startDate ||
                                        !reportData.endDate ||
                                        !reportData.type
                                    ) {
                                        toast.warn("Please fill all required fields.");
                                        return;
                                    }
                                    generate({
                                        variables: {
                                            startDate: format(reportData.startDate, "yyyy-MM-dd"),
                                            endDate: format(reportData.endDate, "yyyy-MM-dd"),
                                            type: reportData.type,
                                            format: reportData.format,
                                            name: reportData.name,
                                            vendor_list: reportData.vendor_list.length
                                                ? reportData.vendor_list
                                                : undefined,
                                            dynamic_values: SelectedFields.length
                                                ? SelectedFields
                                                : undefined,
                                        },
                                        onCompleted: () => {
                                            toast.success("Report generation started.");
                                            setSelectedRange({
                                                startDate: new Date(),
                                                endDate: new Date(),
                                                key: "selection",
                                            });
                                            setReportData({
                                                startDate: new Date(),
                                                endDate: new Date(),
                                                name: "",
                                                format: "",
                                                type: "",
                                                email: "",
                                                vendor_list: [],
                                                SelectedFields: [],
                                            });
                                            setModal(false);
                                        },
                                        onError: (error) => {
                                            toast.error("Error generating report.");
                                            setModal(false);
                                        },
                                    });
                                }}
                                className="mt-4 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md"
                            >
                                Download Report
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Table
                heading="Reports"
                loading={reportLoading && loading}
                searchBox={
                    <div className="flex flex-col  justify-end w-full">
                        <div className="flex justify-end gap-x-2">
                            <button
                                onClick={async () => {
                                    setLoading(true);
                                    refetch();
                                    setTimeout(() => {
                                        setLoading(false);
                                    }, 1000);
                                }}
                                className="h-9  flex items-center gap-x-2 bg-gray-200 text-sm rounded-md text-black px-6"
                            >
                                <RiRefreshLine
                                    className={
                                        "text-lg " + (loading ? " animate-spin duration-300" : "")
                                    }
                                />
                                Refresh
                            </button>
                            <button
                                onClick={() => setModal(true)}
                                className="h-9  flex items-center gap-x-2 bg-edviron_black hover:bg-edviron_black/90 text-sm rounded-md text-white px-6"
                            >
                                <FiDownload className="text-lg" />
                                Download Report
                            </button>
                        </div>
                        <RowsPerPageSelect
                            setItemsPerRow={(e: any) => {
                                setCurrentPage(1);
                                setItemsPerRow(e);
                            }}
                            itemsPerRow={itemsPerRow}
                            className=" justify-start"
                        />
                    </div>
                }
                data={[
                    [
                        "Sr.No",
                        "Duration Covered",
                        "Type",
                        "Status",
                        "Created At",
                        "Download",
                    ],
                    ...(data?.getMerchantReportsLogs?.reports.map((item: any, index: number) => [
                        (currentPage - 1) * itemsPerRow.name + 1 + index,
                        `${new Date(item.start_date).toDateString()} - ${new Date(
                            item.end_date
                        ).toDateString()}`,
                        item.type.replaceAll("_", " "),

                        ["COMPLETED", "DELETED", "FAILED"].includes(item.status) ? (
                            item.status
                        ) : (
                            <div className="flex items-end gap-x-2">
                                <LottiePlayer
                                    animationData={generatingFileAnimation}
                                    width={25}
                                    height={25}
                                />
                                <span className="text-xs text-gray-600">Generating...</span>
                            </div>
                        ),
                        new Date(item.createdAt).toDateString(),
                        <div className="w-[20px]">
                            {item.status === "COMPLETED" && item.url !== "" ? (
                                <a href={item.url}>
                                    <FaDownload className="text-xl text-blue-600 hover:text-blue-700" />
                                </a>
                            ) : (
                                "N/A"
                            )}
                        </div>,
                    ]) || []),
                ]}
                footer={
                    <div className="flex justify-center items-center">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(data?.getMerchantReportsLogs?.totalPages)}
                            onPageChange={handlePageChange}
                        />
                    </div>
                }
            />
        </div>
    );
}